export default "__VITE_ASSET__D41fY0z2__"